module.exports = __webpack_public_path__ + "img/age-confirm-main-img.ea3a7d7c.png";